import { css } from "@emotion/react";

import { BUTTON_SIZES } from "components/DesignComponents/Button/types/enums";
import CopyButton from "components/DesignComponents/CopyButton";
import { TooltipGeneral } from "components/DesignComponents/Tooltips/TooltipGeneral";
import { TOOLTIP_PLACEMENT } from "components/DesignComponents/Tooltips/types/enums";
import { useOverflow } from "shared/hooks/useOverflow";

import { UserSentConfigurationProps } from "./types";

const UserSentConfiguration = ({ fileName }: UserSentConfigurationProps) => {
    const { ref, isOverflowing } = useOverflow(fileName ? [fileName] : []);

    return fileName ? (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                columnGap: "8px"
            })}
        >
            <TooltipGeneral
                title={fileName}
                disableHoverListener={!isOverflowing}
                placement={TOOLTIP_PLACEMENT.Top}
            >
                <span
                    ref={ref}
                    css={css({
                        overflowX: "hidden",
                        textOverflow: "ellipsis"
                    })}
                >
                    {fileName}
                </span>
            </TooltipGeneral>

            <CopyButton size={BUTTON_SIZES.Tiny} copiedValue={fileName} />
        </div>
    ) : (
        <>-</>
    );
};

export default UserSentConfiguration;
